export const getPrice = (sku, currentVariantSku, data = {}) => {
    var _a, _b, _c, _d;
    const productType = data.__typename;
    let minimumPrice;
    if (data) {
        if (productType === "SimpleProduct" || productType === "BundleProduct" || !sku) {
            minimumPrice = (_a = data === null || data === void 0 ? void 0 : data.price_range) === null || _a === void 0 ? void 0 : _a.minimum_price;
        }
        else if (productType === "ConfigurableProduct" && sku) {
            const product = (_c = (_b = data === null || data === void 0 ? void 0 : data.variants) === null || _b === void 0 ? void 0 : _b.find((variant) => { var _a; return ((_a = variant === null || variant === void 0 ? void 0 : variant.product) === null || _a === void 0 ? void 0 : _a.sku) === currentVariantSku; })) === null || _c === void 0 ? void 0 : _c.product;
            if (product) {
                minimumPrice = (_d = product === null || product === void 0 ? void 0 : product.price_range) === null || _d === void 0 ? void 0 : _d.minimum_price;
            }
        }
    }
    return {
        price: minimumPrice && minimumPrice.regular_price.value !== minimumPrice.final_price.value
            ? minimumPrice.regular_price
            : undefined,
        finalPrice: minimumPrice === null || minimumPrice === void 0 ? void 0 : minimumPrice.final_price,
    };
};
//# sourceMappingURL=getPrice.js.map